import { useEffect } from 'react'

import {
  CarePathDefaultTemplate,
  CarePathDefaultTemplateProps,
} from 'components/templates/carePath/landing'

export const Taganil = (props: CarePathDefaultTemplateProps) => {
  useEffect(() => {
    const bodyEle = document.getElementsByTagName('body')[0]
    bodyEle.classList.add(
      'taganil-page',
      'chatwoot-expand-style',
      'replace-chatwoot-icon',
    )
    return () => {
      bodyEle.classList.remove(
        'taganil-page',
        'chatwoot-expand-style',
        'replace-chatwoot-icon',
      )
    }
  }, [])
  return (
    // <MantineProvider
    //   theme={{
    //     ...theme,
    //     components: {
    //       ...theme.components,
    //       ClickableBanner: {
    //         styles: {
    //           bubbleInside: {
    //             borderColor: spotlight?.colorPatterns.primary,
    //           },
    //           bubbleText: {
    //             color: spotlight?.colorPatterns.primary,
    //           },
    //         },
    //       },
    //     },
    //   }}
    // >
    <CarePathDefaultTemplate {...props} />
    // </MantineProvider>
  )
}
